import {
    ClickEvent, DataHeader, DataSourceMode, EditRowDecorator, Label, Switch, TableRow, TableRowDisplayEvent, TableRowMode
} from "@mcleod/components";
import { McLeodClassicIntegration, ModelRow } from "@mcleod/core";
import { AutogenLayoutBrokerageWorkflowProfile } from "./autogen/AutogenLayoutBrokerageWorkflowProfile";
import { BrokerageWorkflowProfileNextStatusSlideout } from "./BrokerageWorkflowProfileNextStatusSlideout";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

export class BrokerageWorkflowProfile extends AutogenLayoutBrokerageWorkflowProfile {

    override onLoad(): void {
        this.validateWorkflowProfileRecordExist();
        this.tableBrokerageWorkflowDetails.onEditLayoutLoaded = this.tableStatusCodesOnEditLoaded();
    }
    
    validateWorkflowProfileRecordExist() {
        const workflowProfileUrl = "lme/powerbroker/BrokerageWorkflowProfile?mode=update&key=";
        const validateProps: DuplicateIdProps = {tableName: "brokerage_workflow", screenName: "BrokerageWorkflowProfile", navigateToUrl: workflowProfileUrl};
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    tableBrokerageWorkflowDetailsOnRowDisplay(event: TableRowDisplayEvent) {
        const switchItem = event.target.findComponentById("switchEndOfWorkflow") as Switch;
        switchItem.printable = false;
    }

    tableStatusCodesOnEditLoaded(): (rowDecorator: EditRowDecorator, tableRow: TableRow) => void {
        return (rowDecorator: EditRowDecorator, tableRow: TableRow) => {
            const brokerageStatusCode = tableRow.data.get("brokerage_status_code");
            const canBeChangedTo = tableRow.data.get("can_be_changed_to");

            const statusCodeLayout = rowDecorator.layout as BrokerageWorkflowProfileNextStatusSlideout;
            const isQuickAddRow = (tableRow.mode == TableRowMode.QUICK_ADD);
            statusCodeLayout.initialize(true, brokerageStatusCode, canBeChangedTo, this.sourceBrokerageWorkflowDetail);
            rowDecorator.labelTitle.text = "Next Status Selection";
            rowDecorator.onSave = this.nextCodesSlideoutOnSave(rowDecorator, tableRow, isQuickAddRow);
        };

    }

    nextCodesSlideoutOnSave(rowDecorator: EditRowDecorator, tableRow: TableRow, isQuickAddRow: boolean): (updatedData: ModelRow | any) => void {
        return async (updatedData: ModelRow | any) => {
            const statusCodeLayout = rowDecorator.layout as BrokerageWorkflowProfileNextStatusSlideout;
            tableRow.data.set("can_be_changed_to", statusCodeLayout.selectedStatusCodes);

            if (isQuickAddRow) {
                const canBeChangedToLabel = tableRow.findComponentById("labelCanBeChangedTo") as Label;
                canBeChangedToLabel.text = statusCodeLayout.selectedStatusCodes;
            }
        };

    }

    sourceBrokerageWorkflowProfileBeforeModeChange(event) {
        this.buttonOpenClassic.visible = event.newMode === DataSourceMode.UPDATE;
    }

    buttonOpenClassicOnClick(event: ClickEvent) {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.brdsp.EntryBrokerageWorkflow", this.mainDataSource.activeRow.get("id"));
    }

    sourceBrokerageWorkflowProfileAfterExecution(event) {
        this.title = "Brokerage Workflow Profiles";
        this.titleEditModeSuffix = this.mainDataSource.activeRow.get("descr");
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxBrokerageStatusCode. */
    textboxBrokerageStatusCodeBeforeLookupModelSearch(event) {
        event.filter.is_active = "Y";
    }
 }
